import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
  Renderer2,
  ViewEncapsulation,
} from '@angular/core';
import { DateTime, Zone } from 'luxon';
import { GeneralService } from '../../../../services/general/general.service';
import { ConfirmDialogComponent } from 'src/app/components/confirm-dialog/confirm-dialog.component';
import { RescheeduleDialogComponent } from 'src/app/components/rescheedule-dialog/rescheedule-dialog.component';
import { ReportDialogComponent } from 'src/app/components/report-dialog/report-dialog.component';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['../../../../../shared-styles/classes.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class IndexComponent implements OnInit {

  public isMobile: any;
  public headerHeight: any = 0;
  public paginate: any = 0;
  public loading: any = false;
  public subscriptions: any = [];
  public dataSource = [];

  public user: any;
  public userInfo: any;

  public displayedColumns: string[] = [
    'teacher',
    'lesson',
    'date',
    'type',
    'status',
    'actions',
  ];
  public isTeacher: any;
  public classesLength: any = 0;

  constructor(
    public general: GeneralService,
    private cdRef: ChangeDetectorRef,
    private renderer: Renderer2,
    private dialog: MatDialog
  ) {

    this.isMobile = this.general.isMobile();
  }

  async ngOnInit() {

    try {

      this.general.setLoading(true);
     
      window.dispatchEvent(new CustomEvent('calendar-hide-label'));
      window.dispatchEvent(new CustomEvent('hide-side-nav'));
      this.intializeSubscriptions();
      await this.getUserInfo();
      await this.getClasses();
    } catch (error) {
      // teacher-class-mine
    } finally {
      this.general.setLoading(false);
    }

    this.user.rol == "teacher" ? this.isTeacher = true : this.isTeacher = false;
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription: any) => {
      subscription.unsubscribe();
    });
  }

  intializeSubscriptions() {
    this.subscriptions = [
      this.general.loading$.subscribe((res) => (this.loading = res)),
    ];
  }

  
  async getUserInfo() {
    const response = await this.general.getUserInfo();
    this.userInfo = response.data;
    this.user = this.userInfo.user;
  }

  // Handle event Listener
  handleEvent(event: any) {
    switch (event.type) {
    }
  }

  async getClasses() {

    const response = await this.general.httpGet('teacher-class-mine', {
      page: this.paginate + 1,
    });

    console.log("response: ", response);

    this.dataSource = response.data.map((e: any) => {
      const timezone = this.general.getCurrentTimezone();

      const datetime = DateTime.fromFormat(e.start, 'yyyy-LL-dd HH:mm:ss', {
        zone: 'UTC',
      }).setZone(timezone);
      const date = this.isMobile
        ? datetime.toFormat('dd/LL HH:mm')
        : datetime.toFormat('dd/LL/yyyy HH:mm');

      const end = DateTime.fromFormat(e.start, 'yyyy-LL-dd HH:mm:ss', {
        zone: 'UTC',
      })
        .setZone(timezone)
        .plus({ hour: 1 })
        .toMillis();

      const now = DateTime.local().setZone(timezone).toMillis();

      if (now > end && e.state === '1') {
        e.state = '7';
      }

      return {
        canRescheedule: !this.checkLessThanThreeHoursFromNow(e.start),
        teacher: e.teacher_data.name,
        lesson: e.lesson_name,
        type: e.is_group,
        teacherImage: e.teacher_data.profile_photo_path,
        date,
        state: Number.parseInt(e.state),
        element: e,
      };
    });

    console.log("this.dataSource: ", this.dataSource);

    this.classesLength = response.total;
  }

  async onChangePage($event: any) {
    this.paginate = $event.pageIndex;
    await this.getClasses();
  }

  async onActionClass(element: any, action: any) {
    switch (action) {
      case 'complete':
        await this.sendActionToAPI(element, action);
        break;
      case 'cancel':
        await this.cancelClass(element, action);
        break;
      case 'reschedule':
        await this.rescheduleClass(element, action);
        break;
      case 'report-incident':
        await this.reportClass(element, action);
        break;
    }
  }

  async sendActionToAPI(element: any, action: any) {

    try {
      this.general.setLoading(true);
      const response = await this.general.httpPost(
        'teacher-class-update-state',
        {
          action,
          id: element.id,
        }
      );

      await this.getClasses();

    } catch (error) {
      console.log(error);
    } finally {
      this.general.setLoading(false);
    }
  }

  async onChatTeacher(teacher: any) {
    const chat = {
      user_id: teacher.element.teacher_id,
      name: teacher.element.teacher_data.name,
      user_photo: teacher.element.teacher_data.profile_photo_path,
      last_message: null,
    };

    localStorage.setItem('current-chat', JSON.stringify(chat));
    await this.general.sleep(10);
    await this.general.navigate('messages');
  }

  async cancelClass(element: any, action: any) {
    // Check Time Class
    const res = this.checkLessThanThreeHoursFromNow(element.start);
    if (!res) {
      await this.sendActionToAPI(element, action);
      this.setStateClass(element.id, 3);
      return;
    }
    // Show Dialog
    const data = {
      title: 'warning-student-dont-refund',
    };

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data,
      autoFocus: false,
    });

    const subscribed = dialogRef.afterClosed().subscribe(async (data) => {
      try {
        subscribed.unsubscribe();

        if (!data) {
          return;
        }
        await this.sendActionToAPI(element, action);
        this.setStateClass(element.id, 3);
      } catch (e: any) {
        console.log(e);
      } finally {
      }
    });
    
  }

  async rescheduleClass(element: any, action: any) {
    // Check Time Class
    const res = this.checkLessThanThreeHoursFromNow(element.start);

    if (res) {
      return;
    }
    const dialogRef = this.dialog.open(RescheeduleDialogComponent, {
      data: {
        teacherId: element.teacher_id,
        maxHours: 1,
        title: 'select-the-new-hour',
      },
      autoFocus: false,
      maxHeight: '800px',
      maxWidth: '600px',
      width: '100%',
      height: '100%',
    });

    const subscribed = dialogRef.afterClosed().subscribe(async (data) => {
      try {
        this.general.setLoading(true);

        subscribed.unsubscribe();

        if (!data) {
          return;
        }
        const res = await this.general.httpPost('booking-reschedule', {
          booking_start_datetime: data.booking_start_datetime,
          booking_end_datetime: data.booking_end_datetime,
          booking_id: element.booking_id,
        });

        const teacher_class: any = this.dataSource.find(
          (data: any) => data.element.id === element.id
        );
        if (!teacher_class) {
          return;
        }
        teacher_class.state = 1;
        teacher_class.start = DateTime.fromISO(data.booking_start_datetime)
          .setZone('UTC')
          .toFormat('yyyy-LL-dd HH:mm:ss');

        const date = this.isMobile
          ? DateTime.fromISO(data.booking_start_datetime)
              .setZone(this.general.getCurrentTimezone())
              .toFormat('dd/LL HH:mm')
          : DateTime.fromISO(data.booking_start_datetime)
              .setZone(this.general.getCurrentTimezone())
              .toFormat('dd/LL/yyyy HH:mm');
        teacher_class.date = date;
      } catch (e: any) {
        console.log(e);
      } finally {
        this.general.setLoading(false);
      }
    });
  }

  async reportClass(element: any, action: any) {
    const dialogRef = this.dialog.open(ReportDialogComponent, {
      data: {
        title: 'report-incidence-text',
      },
      autoFocus: false,
      maxHeight: '400px',
      maxWidth: '600px',
      width: '100%',
      height: '100%',
    });

    const subscribed = dialogRef.afterClosed().subscribe(async (data) => {
      try {
        this.general.setLoading(true);

        subscribed.unsubscribe();

        if (!data) {
          return;
        }
        console.log(data);
        const body = {
          id: element.id,
        };
        await this.general.httpPost('dispute-open', {
          booking_id: element.booking_id,
          type: 'booking',
          message: data,
        });

        this.setStateClass(element.id, 5);
      } catch (e: any) {
        console.log(e);
      } finally {
        this.general.setLoading(false);
      }
    });
  }

  openSupport() {
    //  window.location.href = 'mailto:soporte@wordiix.com';
    window.location.href = 'https://wordiix.com/soporte';
  }

  checkLessThanThreeHoursFromNow(date: any) {
    const timezone = this.general.getCurrentTimezone();
    const start = DateTime.fromFormat(date, 'yyyy-LL-dd HH:mm:ss', {
      zone: 'UTC',
    })
      .setZone(timezone)
      .toMillis();
    const now = DateTime.local().setZone(timezone).toMillis();
    return now > start - 1000 * 60 * 60 * 3;
  }

  checkLessThanNow(date: any) {
    const timezone = this.general.getCurrentTimezone();
    const start = DateTime.fromFormat(date, 'yyyy-LL-dd HH:mm:ss', {
      zone: 'UTC',
    })
      .setZone(timezone)
      .toMillis();
    const now = DateTime.local().setZone(timezone).toMillis();
    return now > start;
  }

  setStateClass(id: number, state: number) {
    const teacher_class: any = this.dataSource.find(
      (data: any) => data.element.id === id
    );
    if (!teacher_class) {
      return;
    }
    teacher_class.state = state;  
    
    teacher_class.element.state = state.toString();
  }
}
